import $ from 'jquery';

function SkipAutoPayment(cardSelector) {
  var skipping = false;
  $(cardSelector).on('click', '.js-skip-next-occurrence', function (e) {
    if (!skipping) {
      skipping = true;
      var $this = $(this);
      var url = $this.data('url');
      e.preventDefault();
      $.ajax({url: url, method: "post", dataType: 'json'})
        .done(function (data) {
          skipping = false;
          $this.closest('.js-auto-payment').replaceWith(data.skipped_payment_html);
          var table = $('.js-past-payments-table');
          table.prepend(data.skipped_past_payment_html);
          if (table.hasClass('u-hidden')) {
            table.removeClass('u-hidden');
            $('.js-no-past-payments').addClass('u-hidden');
          }
        })
        .error(function ()
        {
          skipping = false;
        });
    }
  });
}

export default SkipAutoPayment;
